import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-and-drop reordering of Chapters within a Playbook's Mission Control
// show page (card #4459). Modelled on album_image_sortable_controller.js /
// runbook_node_sortable_controller.js -- a plain fetch PATCH on drop, no
// Turbo Stream response expected (the DOM is already in the dropped order).

export default class extends Controller {
  static targets = ["list"]
  static values = { url: String }

  connect() {
    if (!this.hasListTarget) return

    this._sortable = Sortable.create(this.listTarget, {
      handle: "[data-sort-handle]",
      animation: 150,
      ghostClass: "opacity-40",
      chosenClass: "sortable-chosen-ring",
      forceFallback: true,
      fallbackOnBody: false,
      swapThreshold: 0.65,
      onEnd: () => this._persistOrder()
    })
  }

  disconnect() {
    this._sortable?.destroy()
    this._sortable = null
  }

  _persistOrder() {
    const rows = this.listTarget.querySelectorAll("[data-chapter-id]")
    const chapterIds = Array.from(rows).map(el => el.dataset.chapterId).filter(Boolean)
    if (chapterIds.length === 0 || !this.hasUrlValue) return

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify({ chapter_ids: chapterIds })
    })
  }
}
